import axios from 'axios';
import { useEffect, useState } from 'react';
import { publicText } from '../publicText';

export const ORIGIN = process.env.REACT_APP_BACKEND_URL;
export const TOKEN_KEY = 'allrounder_admin_jwt';
export const api = axios.create({ baseURL: `${ORIGIN}/api/platform` });
export const adminApi = axios.create({ baseURL: `${ORIGIN}/api/platform/admin` });
adminApi.interceptors.request.use(config => {
  config.headers.Authorization = `Bearer ${localStorage.getItem(TOKEN_KEY) || ''}`;
  return config;
});
export const message = e => typeof e?.response?.data?.detail === 'string' ? e.response.data.detail : Array.isArray(e?.response?.data?.detail) ? 'Please check your details and try again.' : '요청을 처리하지 못했습니다. 다시 시도해 주세요.';
export const pick = (value, lang = 'ko') => typeof value === 'string' ? value : value?.[lang] || value?.en || value?.ko || '';
export const mediaSrc = value => value?.startsWith('/api/') ? `${ORIGIN}${value}` : value;
export const eventHref = e => e.type === 'external' ? e.external_url : `/events/${e.slug}`;
export const dateText = (value, lang = 'ko') => value ? `${new Intl.DateTimeFormat(lang, {timeZone:'Australia/Brisbane', year:'numeric',month:'short',day:'numeric',hour:'2-digit',minute:'2-digit',hour12:false}).format(new Date(value))} AEST` : publicText(lang,'See original page for dates');
export const toLocalDate = v => v ? new Date(new Date(v).getTime() + 10*3600000).toISOString().slice(0,16) : '';
export function useResource(path) {
  const [state,setState] = useState({data:null,error:'',loading:true});
  useEffect(() => { let live=true; setState({data:null,error:'',loading:true}); api.get(path).then(r=>live&&setState({data:r.data,error:'',loading:false})).catch(e=>live&&setState({data:null,error:message(e),loading:false})); return ()=>{live=false;}; },[path]);
  return state;
}
export function useMediaUrl(value, preview = false, enabled = true) {
  const [blob,setBlob] = useState('');
  useEffect(() => {
    setBlob('');
    if (!enabled || !preview || !value?.startsWith('/api/platform/media/')) return;
    let active=true, url;
    adminApi.get(`/media/${value.split('/').pop()}`,{responseType:'blob'}).then(r=>{if(active){url=URL.createObjectURL(r.data);setBlob(url);}}).catch(()=>{});
    return ()=>{active=false;if(url) URL.revokeObjectURL(url);};
  },[value,preview,enabled]);
  return !enabled ? '' : preview && value?.startsWith('/api/platform/media/') ? blob : mediaSrc(value);
}